import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';

import Box from '@mui/material/Box';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { solutionSelect, solutionDelete } from "../../../actions/solution";

import { useNavigate, useParams } from 'react-router-dom';
import { Link } from '@mui/material';

import * as common from "../../../lib";

export default function NoticeView() {

  const idx  = useParams().idx;
  // console.log("idx : ", idx);
  let prevPage  = useParams().prevPage;
  // console.log("prevPage : ", prevPage);
  
  if (prevPage === undefined)
    prevPage = 1;

  // 리듀서 값들 저장
  const userInfo = useSelector(state => state.auth);
  // console.log("userInfo : ", userInfo);

  const solution_select = useSelector(state => state.solution?.select);
  // console.log("solution_select : ", solution_select);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onDelete = (event) => {

      event.preventDefault();
      
      if(userInfo.isLoggedIn)
      {
        const sendDelete = {
          idx: idx,
        }
    
        // console.log("sendDelete : ", sendDelete);
    
        if (window.confirm("정말 삭제하시겠습니까??") == true){    //확인
    
          // 여기서 디스패치로~
          dispatch(solutionDelete(sendDelete))
          .then(data => 
          {
            // console.log("bbsDelete data : ", data);
    
            if (!data.success)
            {
              alert(data.msg);
              return;
            }
            else
            {
              navigate(`/dashboard/SolutionList/${prevPage}`);
            }
              
          })
          .catch(e => {
            console.log(e);
          });	
        }
        else
        {   //취소
        
          return;
        
        }
      }
      else
      {
        alert("로그인 후에 삭제할 수 있습니다.");
        return;
      }
    }

    useEffect(() => {
        
        // 여기서 디스패치로~
        dispatch(solutionSelect(idx))
        .then(data => 
        {
          // console.log("data : ", data);
        })
        .catch(e => {
          console.log(e);
        });

        return () => {      // 언마운트
            console.log("언마운트!");
        };

    }, [dispatch])

  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Box
        sx={{height:'35px',
            '& > :not(style)': { m: 1, width: '100%' },
        }}
        >
        - 이름 : {solution_select?.mem_idx === 0 ? solution_select?.name || "" : solution_select?.mem_name || ""} ({solution_select?.mem_idx === 0 ? "비회원" : "회원"})
        </Box>
        <Box
        sx={{height:'35px',
            '& > :not(style)': { m: 1, width: '100%' },
        }}
        >
        - 이메일 : {solution_select?.mem_idx === 0 ? solution_select?.email || "" : solution_select?.mem_email || ""}
        </Box>
        <Box
        sx={{height:'35px',
            '& > :not(style)': { m: 1, width: '100%' },
        }}
        >
        - 등록일 : {solution_select?.reg_date || ""}
        </Box>
        <Box
        sx={{height:'35px',
            '& > :not(style)': { m: 1, width: '100%' },
        }}
        >
        - 카테고리 : {common.returnSolutionType(solution_select?.sc_category_idx) || ""}
        </Box>
        <Box>
        - 제목 : {solution_select?.title || ""}
        </Box>
        <Box
        sx={{ marginTop: '20px',
              whiteSpace: 'pre-line',
              overflowX: 'auto',
              wordBreak: 'break-all',
            '& > :not(style)': { m: 1, width: '100%' },
        }}>
        * 내용 <br></br>{solution_select?.question || ""}
        </Box>
        <Box
        sx={{ marginTop: '20px',
              whiteSpace: 'pre-line',
              overflowX: 'auto',
              wordBreak: 'break-all',
            '& > :not(style)': { m: 1, width: '100%' },
        }}
        >
        * 답변 <br></br>{solution_select?.answer || ""}
        </Box>
        <Box
        sx={{height:'35px', wordBreak: 'break-all',
            '& > :not(style)': { m: 1, width: '100%' },
        }}
        >
        - 답변일 : {solution_select?.answer_reg_date || ""}
        </Box>
        <Divider />
        <Box
        sx={{ marginTop: '20px',
              whiteSpace: 'pre-line',
              overflowX: 'auto',
              wordBreak: 'break-all',
            '& > :not(style)': { m: 1 },
        }}
        >
        {solution_select?.photo_file === "" ? "" : <img src={common.returnImgSrc(solution_select?.photo_path, solution_select?.photo_file)} width={400} /> }
        </Box>
      </CardContent>
      <CardActions>
        <Link href={`/dashboard/SolutionList/${prevPage}`} underline="none">목록</Link>
        <Link href={`/dashboard/SolutionModify/${idx}/${prevPage}`} underline="none">수정</Link>
        <Link href={`/dashboard/SolutionModify/${idx}/${prevPage}`} underline="none">답변</Link>
        <Link onClick={(e)=>onDelete(e)} value={idx} underline="none">삭제</Link>
      </CardActions>
    </Card>
  );
}